import { Collapse } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import Performance from "./Performance";
import CashFlow from "./cashFlow/CashFlow";

const Dashboard = () => {
  const { t } = useTranslation();

  const items = [
    {
      key: 1,
      label: t("projectsManagement.dashboard.performanceTitle"),
      className: "mb-1em",
      children: <Performance />,
    },
    {
      key: 2,
      label: t("projectsManagement.dashboard.cashFlowTitle"),
      className: "mb-1em",
      children: <CashFlow />,
    },
  ];

  return (
    <>
      <Collapse items={items} className="mb-1em" />
    </>
  );
};

export default Dashboard;
